import { jsx as r, jsxs as a } from "react/jsx-runtime";
import { ProductCardSeeMoreHorizontal as s } from "./ProductCardSeeMoreHorizontal.js";
/* empty css                                                                                 */const l = ({
  text: e,
  link: o,
  taggingEvent: c,
  variant: d
}) => d === "horizontal" ? /* @__PURE__ */ r(
  s,
  {
    text: e,
    link: o,
    taggingEvent: c
  }
) : /* @__PURE__ */ a("div", { className: "product-card-see-more", children: [
  /* @__PURE__ */ r("div", { className: "product-card-see-more-text-container", children: /* @__PURE__ */ a("p", { className: "product-card-see-more-text", children: [
    "Veja mais ",
    /* @__PURE__ */ r("br", {}),
    /* @__PURE__ */ r("span", { children: e })
  ] }) }),
  /* @__PURE__ */ r(
    "a",
    {
      className: "product-card-see-more-link",
      onClick: c,
      href: o,
      children: "Ver mais"
    }
  )
] });
export {
  l as ProductCardSeeMore
};
